//#region src/internal/tool-helpers/formatting.ts
/**
* Helper function to format assignedTo field for display
*/
function formatAssignedTo(assignedTo) {
	if (!assignedTo) return "Unassigned";
	if (typeof assignedTo === "string") return assignedTo;
	if (typeof assignedTo === "object" && assignedTo.name) return assignedTo.name;
	return "Unknown";
}

//#endregion
export { formatAssignedTo };
//# sourceMappingURL=formatting-Dh3LlFmw.js.map